















































































































































































import Vue from 'vue';

export default Vue.extend({
  name: 'Footer',
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
});
